import React from 'react';
import TagFilter from '@/components/filters/TagFilter/TagFilter';

interface ContactNameFilterProps {
  selectedContactName: string | null;
  setSelectedContactName: (contactName: string | null) => void;
}

const ContactNameFilter: React.FC<ContactNameFilterProps> = ({ selectedContactName, setSelectedContactName }) => {
  if (!selectedContactName) {
    return null;
  }

  return <TagFilter variant="options-range-filter-style" title={selectedContactName} onClose={() => setSelectedContactName(null)} />;
};

export default ContactNameFilter;
